// GENERAL
export const GENERAL_SET_FILTER_BAR = "GENERAL_SET_FILTER_BAR";

// USER MODULE
export const USER_SET_USER = "USER_SET_USER";
export const USER_SET_ACCESS_TOKEN = "USER_SET_ACCESS_TOKEN";
export const USER_SET_REFRESH_TOKEN = "USER_SET_REFRESH_TOKEN";
export const USER_SET_SELECTED_COMMUNITY = "USER_SET_SELECTED_COMMUNITY";
export const USER_SET_IS_LOGGED_IN = "USER_SET_IS_LOGGED_IN";
export const USER_SET_PERMISSIONS = "USER_SET_PERMISSIONS";

//PROPERTY MODULE
export const PROPERTY_SET_LIST = "PROPERTY_SET_LIST";
export const PROPERTY_SET_COUNT = "PROPERTY_SET_COUNT";
export const PROPERTY_SET_LIST_LOADING = "PROPERTY_SET_LIST_LOADING";
export const PROPERTY_SET_DETAIL_LOADING = "PROPERTY_SET_DETAIL_LOADING";
export const PROPERTY_SET_SELECTED_PROPERTY = "PROPERTY_SET_SELECTED_PROPERTY";
export const PROPERTY_SET_FILTER = "PROPERTY_SET_FILTER";
export const PROPERTY_SET_FROM_FILTER = "PROPERTY_SET_FROM_FILTER";
export const PROPERTY_SET_LENGTH_FILTER = "PROPERTY_SET_LENGTH_FILTER";
export const PROPERTY_SET_SORT_FILTER = "PROPERTY_SET_SORT_FILTER";
export const PROPERTY_SET_REGION_FILTER = "PROPERTY_SET_REGION_FILTER";
export const PROPERTY_SET_TRANSACTION_TYPE_FILTER = "PROPERTY_SET_TRANSACTION_TYPE_FILTER";
export const PROPERTY_SET_ADVISOR_NAME_FILTER = "PROPERTY_SET_ADVISOR_NAME_FILTER";
export const PROPERTY_SET_PROPERTY_CODE_FILTER = "PROPERTY_SET_PROPERTY_CODE_FILTER";
export const PROPERTY_SET_PROPERTY_TYPE_FILTER = "PROPERTY_SET_PROPERTY_TYPE_FILTER";
export const PROPERTY_SET_BEDROOMS_FILTER = "PROPERTY_SET_BEDROOMS_FILTER";
export const PROPERTY_SET_BEDROOMS_EXACTLY_FILTER = "PROPERTY_SET_BEDROOMS_EXACTLY_FILTER";
export const PROPERTY_SET_FOUNDATION_FROM_FILTER = "PROPERTY_SET_FOUNDATION_FROM_FILTER";
export const PROPERTY_SET_FOUNDATION_TO_FILTER = "PROPERTY_SET_FOUNDATION_TO_FILTER";
export const PROPERTY_SET_AREA_FROM_FILTER = "PROPERTY_SET_AREA_FROM_FILTER";
export const PROPERTY_SET_AREA_TO_FILTER = "PROPERTY_SET_AREA_TO_FILTER";
export const PROPERTY_SET_OVERALL_PRICE_FROM_FILTER = "PROPERTY_SET_OVERALL_PRICE_FROM_FILTER";
export const PROPERTY_SET_OVERALL_PRICE_TO_FILTER = "PROPERTY_SET_OVERALL_PRICE_TO_FILTER";
export const PROPERTY_SET_SEGMENT_PRICE_FROM_FILTER = "PROPERTY_SET_SEGMENT_PRICE_FROM_FILTER";
export const PROPERTY_SET_SEGMENT_PRICE_TO_FILTER = "PROPERTY_SET_SEGMENT_PRICE_TO_FILTER";
export const PROPERTY_SET_FACILITIES_FILTER = "PROPERTY_SET_FACILITIES_FILTER";
export const PROPERTY_SET_PARKING_SPACE_FILTER = "PROPERTY_SET_PARKING_SPACE_FILTER";
export const PROPERTY_SET_PARKING_SPACE_EXACTLY_FILTER = "PROPERTY_SET_PARKING_SPACE_EXACTLY_FILTER";
export const PROPERTY_SET_TOTAL_FLOORS_FILTER = "PROPERTY_SET_TOTAL_FLOORS_FILTER";
export const PROPERTY_SET_TOTAL_FLOORS_EXACTLY_FILTER = "PROPERTY_SET_TOTAL_FLOORS_EXACTLY_FILTER";
export const PROPERTY_SET_PROPERTY_FLOORS_FROM_FILTER = "PROPERTY_SET_PROPERTY_FLOORS_FROM_FILTER";
export const PROPERTY_SET_PROPERTY_FLOORS_TO_FILTER = "PROPERTY_SET_PROPERTY_FLOORS_TO_FILTER";
export const PROPERTY_SET_TOTAL_UNIT_PER_FLOORS_FILTER = "PROPERTY_SET_TOTAL_UNIT_PER_FLOORS_FILTER";
export const PROPERTY_SET_TOTAL_UNIT_PER_FLOORS_EXACTLY_FILTER = "PROPERTY_SET_TOTAL_UNIT_PER_FLOORS_EXACTLY_FILTER";
export const PROPERTY_SET_PROPERTY_UNIT_FILTER = "PROPERTY_SET_PROPERTY_UNIT_FILTER";
export const PROPERTY_SET_PROPERTY_UNIT_EXACTLY_FILTER = "PROPERTY_SET_PROPERTY_UNIT_EXACTLY_FILTER";
export const PROPERTY_SET_BALCONY_FILTER = "PROPERTY_SET_BALCONY_FILTER";
export const PROPERTY_SET_CABINET_FILTER = "PROPERTY_SET_CABINET_FILTER";
export const PROPERTY_SET_FLOORING_FILTER = "PROPERTY_SET_FLOORING_FILTER";
export const PROPERTY_SET_WARE_HOUSE_FILTER = "PROPERTY_SET_WARE_HOUSE_FILTER";
export const PROPERTY_SET_PROPERTY_DIRECTION_FILTER = "PROPERTY_SET_PROPERTY_DIRECTION_FILTER";
export const PROPERTY_SET_PICTURE_FILTER = "PROPERTY_SET_PICTURE_FILTER";
export const PROPERTY_SET_LIST_ADVISOR_PROPERTIES = "PROPERTY_SET_LIST_ADVISOR_PROPERTIES";

// REGION MODULE
export const REGION_SET_LIST = "REGION_SET_LIST";